/** Legacy strings for التقارير الشخصية — Admin/UserDetailsAdmin.ar.resx + Resources.ar.resx. */
export const strings = {
  actionFailed: 'تعذر إتمام العملية',
  fail: {
    resetTry: 'تعذر تصفير محاولة الاختبار',
    surveyReport: 'تعذر تحميل تقرير الاستبيان',
  },
  title: 'التقارير الشخصية', // UserDetailsAdmin.PageResource1.Title
  errorHeading: 'رسالة الخطأ', // General.ErrorMessageLabel
  errorBody: 'ثمة خطأ حدث أثناء معالجة الطلب أو أن المستخدم غير موجود', // UserDetailsAdmin.UserDetailsErrorMessage
  notFound: 'المستخدم غير موجود',
  notFoundHint: 'قد يكون الحساب قد حذف، أو أن اسم المستخدم في الرابط غير صحيح',
  backToUsers: 'العودة إلى قائمة المستخدمين',

  /* شريط الأقسام: أسماء مجردة. الصفحة لمستخدم واحد، فلا يكرر أي بند كلمة «المستخدم». */
  nav: {
    activities: 'الأنشطة',
    statusLogs: 'سجل الحالات',
    programs: 'البرامج',
    examTries: 'محاولات الاختبارات',
    policies: 'السياسات',
    phishing: 'الاصطياد',
    securityReports: 'الحوادث السيبرانية',
    assessments: 'القياسات',
    surveys: 'الاستبيانات',
    points: 'النقاط والمستويات',
    pointsLog: 'سجل العمليات',
    about: {
      activities: 'كل ما فعله هذا المستخدم في المنصة، الأحدث أولا.',
      statusLogs: 'متى فعل الحساب أو أوقف أو تغير، ومن فعل ذلك.',
      programs: 'البرامج المسندة إلى هذا المستخدم، وإلى أين وصل في كل منها.',
      examTries: 'كم محاولة استهلكت في كل اختبار، وطريقة لمنح المزيد.',
      policies: 'السياسات التي طلب من هذا المستخدم قراءتها، وأيها قرأ.',
      phishing: 'كيف تعامل هذا المستخدم مع كل حملة اصطياد تجريبية.',
      securityReports: 'الحوادث التي أبلغ عنها هذا المستخدم.',
      assessments: 'القياسات التي خاضها هذا المستخدم ونتائجه فيها.',
      surveys: 'الاستبيانات التي أرسلت إلى هذا المستخدم، وهل أجاب عنها.',
      points: 'النقاط المكتسبة، والمستوى الذي تبلغه، والشارات على الطريق.',
      pointsLog: 'كل ربح أو خسارة للنقاط، وسببها.',
    },
  },

  tabs: {
    attributes: 'بيانات المستخدم', // UserDetailsAdmin.UserDetailsTitle
    activities: 'أنشطة المستخدم', // UserDetailsAdmin.UserActivitiesTitle
    statusLogs: 'سجل حالات المستخدم', // Resources."User Status Log"
    policies: 'تفاصيل سياسات الأمن السيبراني', // UserDetailsAdmin.ReportTitle.UserPoliciesDetails
    programs: 'ملخص البرامج التدريبية', // UserDetailsAdmin.ReportTitle.UserProgramsSummary
    examTries: 'محاولات الاختبارات', // UserDetailsAdmin.ReportTitle_ExamRetake
    phishing: 'تقرير الاصطياد', // Resources.PhishingReport
    securityReports: 'الحوادث السيبرانية', // SecurityReports.PageResource1.Title
    assessments: 'القياسات', // Assessments.PageResource1.Title
    surveys: 'الاستبيانات', // Surveys.PageResource1.Title
    points: 'النقاط والمستويات', // Resources.PointsLevels
    pointsLog: 'سجل العمليات', // Resources.PointsTransactions
  },

  /**
   * T1 — the read-only field grid.
   *
   * The trailing colons are gone from the four labels that carried them: these
   * are field labels sitting ABOVE their value, not `label: value` runs, and in
   * an RTL line a stray colon lands at the wrong edge.
   */
  profile: {
    arabicName: 'الإسم بالعربية',
    englishName: 'الإسم بالإنجليزية',
    loginProvider: 'طريقة الدخول',
    profileUpdateStatus: 'حالة تحديث البيانات',
    updated: 'تم التحديث',
    notUpdated: 'لم يتم التحديث',
    termsStatus: 'حالة الموافقة على شروط الاستخدام',
    agreed: 'تمت الموافقة',
    notAgreed: 'لم تتم الموافقة',
    license: 'الرخصة', // Resources.License
    startDate: 'تاريخ البداية', // Resources.StartDate
    manualStatus: 'حالة مشاهدة دليل المستخدم',
    viewed: 'تم الاطلاع',
    notViewed: 'لم يتم الاطلاع',
    email: 'البريد الالكتروني', // Resources."Email Address"
    lastLogin: 'تاريخ آخر دخول', // Resources."Last Login Date"
    sendEmail: 'إرسال بريد', // NotificationSettings.BtnSendTrialEmailRes.Text
  },

  /** إرسال بريد — Views/UserDetailsAdmin/NotifyUser.cshtml + `#mdlSendEmail`. */
  emailModal: {
    title: 'إرسال بريد', // UserDetailsAdmin.SendEmail_Header
    messageTitle: 'عنوان الرسالة', // NotificationSettings.TxtMessageTitle
    sendDate: 'تاريخ الإرسال', // UserDetailsAdmin.LblSendDate
    messageBody: 'نص الرسالة', // UserDetailsAdmin.LblMessageBody
    submit: 'جدولة البريد', // UserDetailsAdmin.BtnSendMail
    missingTitle: 'عنوان الرسالة مطلوب', // UserDetailsAdmin.MissingMessageTitle
    missingSendTime: 'تاريخ الإرسال مطلوب', // UserDetailsAdmin.MissingSendTime
    missingBody: 'نص الرسالة مطلوب', // UserDetailsAdmin.MissingMessageBody
    /* The outcome. This one used to be written into the page in Arabic, so an
       administrator working in English was told "تم جدولة البريد بنجاح". */
    scheduled: 'تم جدولة البريد بنجاح',
    failed: 'تعذر جدولة البريد',
  },

  /** The standing strip on the identity band. Not legacy — the legacy page
      carries no figures at all, which is what made it read as a shell. */
  standing: {
    badges: 'الأوسمة',
    noRisk: 'لا يوجد',
  },

  activities: {
    name: 'اسم النشاط', // General.ActivityNameLabel
    date: 'تاريخ النشاط', // General.ActivityDateLabel
    details: 'تفاصيل', // General.ActivityDetailsLabel
  },

  statusLogs: {
    status: 'الحالة', // Resources.Status
    date: 'التاريخ', // Resources.Timestamp
    notes: 'ملاحظات', // Resources.Notes
    /** UserStatus enum → Arabic, Logs.cshtml:44-58. */
    values: {
      '0': 'نشط', // Resources.ACTIVEE
      '1': 'مستقيل',
      '2': 'في انتظار تأكيد الاستقالة',
      '3': 'موقوف', // Resources.SUSPENDEDD
      '4': 'في انتظار تفعيل الحساب',
      '5': 'منتهي الصلاحية',
    },
  },

  policies: {
    title: 'السياسة', // General.UserPoliciesDetails_PolicyTitle
    isDownloaded: 'تم التحميل',
    downloadDate: 'تاريخ أخر تحميل',
    status: 'الحالة', // Resources.Status
    statusDate: 'تاريخ آخر حاله',
    yes: 'نعم', // Resources.Yes
    no: 'لا', // Resources.No
    accepted: 'تمت الموافقة',
    notAccepted: 'لم تتم الموافقة',
  },

  securityReports: {
    index: 'م',
    id: 'رقم البلاغ',
    title: 'عنوان البلاغ',
    category: 'الفئة',
    createdOn: 'تاريخ الإنشاء',
    lastUpdate: 'آخر تحديث',
    state: 'حالة البلاغ',
    /** SecurityReportState, LanguageConstants.cs:59-69. */
    states: {
      '0': 'جديد',
      '1': 'قيد العمل',
      '2': 'منتهي (بلاغ صحيح)',
      '3': 'ملغي (بلاغ خاطئ)',
    },
  },

  examTries: {
    resetDone: 'تمت إعادة الضبط بنجاح',
    exam: 'الاختبار', // ResetExamCounter.ExamField.HeaderText
    allowed: 'العدد المسموح', // AllowedTriesField.HeaderText
    used: 'محاولات المستخدم', // UserTriesField.HeaderText
    reset: 'إعادة ضبط', // ResetField.HeaderText
  },

  points: {
    positive: 'النقاط الإيجابية', // Resources.PositivePoints
    negative: 'النقاط السلبية', // Resources.NegativePoints
    riskLevel: 'مستوى الخطر', // Resources.RiskLevel
    badges: 'الشارات', // Resources.PointsBadges
    description:
      'تمنح المكافآت للمتعلمين عند إتمام أنشطة رئيسية مثل مشاهدة الدورات، اجتياز الاختبارات، وقراءة السياسات.\nيتم منح النقاط أو الشارات أو الإنجازات تلقائيا حسب التقدم.\nتساعد هذه التحفيزات في زيادة التفاعل وتشجيع التعلم المستمر.', // Resources.gamification_points_activities_description
  },

  pointsLog: {
    activity: 'نوع النشاط', // Resources.EventType
    date: 'التاريخ', // Resources.Timestamp
    points: 'النقاط', // Resources.Points
    percentage: 'النسبة في حالة التكرار', // Resources.PercentageOnDuplication
    type: 'نوع النقاط', // Resources.PointsType
    opposite: 'تأثير عكسي؟', // Resources.EffectOpposite
  },

  /**
   * T5 — ملخص البرامج التدريبية, and the two tables that open out of it.
   *
   * The legacy stacks two full-screen modals to get from a programme to its
   * courses to an exam's attempts. One sheet walks the same path instead, with
   * a way back at the top of it — a modal opened over a modal has no way back
   * except closing both.
   */
  programs: {
    summary: 'ملخص البرامج التدريبية', // UserDetailsAdmin.ReportTitle_UserProgramsSummary
    programsCount: 'البرامج التدريبية', // General.ProgramsText
    coursesCount: 'الدورات التدريبية', // LearningProgramsReports.CoursesListTitle
    successPercentage: 'نسبة النجاح', // LearningProgramsReports.LocSuccessPercentage
    /* Joined around the count rather than glued after it: a figure at the END
       of an Arabic run drags the separator to the wrong side of itself. With
       Arabic either side of it the number stays where it was written. */
    successOf: 'نسبة النجاح من أصل',
    watchHint: 'متوسط المشاهدة لكل دورة',
    /* `نسب المشاهده` in the resx — the same two words, spelled. */
    watchPercentage: 'نسبة المشاهدة', // Resources."Watching Percentage"
    title: 'البرنامج', // General.UserProgramsSummary_ProgramTitle
    state: 'الحالة', // General.UserProgramsSummary_State
    details: 'تفاصيل', // UserDetailsAdmin.HeaderProgramDetails.HeaderText
    states: { 0: 'مكتمل', 1: 'قيد التنفيذ', 2: 'لم يبدأ' },
    noPrograms: 'لم يسجل هذا المستخدم في أي برنامج تدريبي',
  },

  courses: {
    title: 'ملخص الدورات التدريبية', // UserDetailsAdmin.ReportTitle_grdVwCoursesSummary
    name: 'الدورة', // General.UserCoursesSummary_courseTitle
    startDate: 'تاريخ البدء', // General.UserCoursesSummary_courseStartDate
    endDate: 'تاريخ الانتهاء', // General.UserCoursesSummary_courseEndDate
    state: 'حالة الاختبار', // General.UserCoursesSummary_courseState
    percentage: 'النسبة %', // General.UserCoursesSummary_ExamPercentage
    tries: 'محاولات الاختبار', // General.UserCoursesSummary_ExamTries
    watchState: 'حالة المشاهدة', // General.UserCoursesSummary_WatchState
    states: { passed: 'ناجح', failed: 'راسب' },
    noExam: 'بدون اختبار',
  },

  exams: {
    title: 'اختبارات المستخدم', // UserDetailsAdmin.ReportTitle_UserTests
    name: 'اسم الاختبار', // General.ExamNameLabel
    course: 'الدورة', // General.CourseTitle
    date: 'تاريخ الاختبار', // General.ExamDateLabel
    percentage: 'النسبة %', // General.DegreeLabel
    state: 'حالة الاختبار', // General.examState
    noExams: 'لا يوجد اختبار لهذه الدورة',
    back: 'رجوع إلى الدورات',
  },

  /** T7 — تقرير الاصطياد, PhishingTable.cshtml. */
  phishing: {
    campaign: 'الاسم', // Resources.Name
    status: 'الحالة', // Resources.Status
    reportingDate: 'تاريخ الإبلاغ', // Resources.ReportingDate
    details: 'التفاصيل', // Resources.Details
    timeline: 'مسار الحملة',
    /** PhishingUserStatus → Arabic, PhishingTable.cshtml:86-100. */
    /* PhishingUserStatus is -1..4, NOT 0..5 — the transcription from
       PhishingTable.cshtml read the enum MEMBERS as literals and shifted every
       label by one, so a recipient who submitted credentials (3) was labelled
       "clicked a link". API_FINDINGS.md §54. */
    states: {
      '-1': 'مجدولة', // PhishingUserStatus.Scheduled
      '0': 'تم الإرسال', // PhishingUserStatus.Sent
      '1': 'تم فتح البريد', // PhishingUserStatus.EmailOpened
      '2': 'تم فتح الرابط', // PhishingUserStatus.LinkClicked
      '3': 'تم إدخال البيانات', // PhishingUserStatus.DataSubmitted
      '4': 'تم الإبلاغ', // PhishingUserStatus.UserReported
    },
  },

  /** T9 — القياسات, Assessments.cshtml. */
  assessments: {
    index: 'م', // Assessments.TableHead_1
    title: 'العنوان', // Assessments.TableHead_2
    state: 'الحالة', // Assessments.TableHead_5
    mandatory: 'الإلزامية', // Assessments.TableHead_6
    /* `AssessmentDto` has no start or end date; it has the score and the date it was
       taken, so those are the columns. */
    score: 'النتيجة',
    completedOn: 'تاريخ القياس',
  },

  /** T10 — الاستبيانات, Surveys.cshtml. */
  surveys: {
    index: 'م', // SurveysManagement.TableHead_1
    title: 'العنوان', // SurveysManagement.TableHead_2
    createdOn: 'تاريخ الإنشاء', // SurveysManagement.TableHead_3
    mandatory: 'الإلزامية', // SurveysManagement.TableHead_6
    state: 'الحالة', // SurveysManagement.TableHead_5
    download: 'تحميل التفاصيل', // SurveysManagement.TableHead_8
    answered: 'تمت الإجابة',
    notAnswered: 'لم تتم الإجابة',
    notAnsweredHint: 'لم يجب المستخدم على هذا الاستبيان', // SurveysManagement.SurveyNotAnsweredMessage
    downloaded: 'تمت العملية بنجاح',
  },

  yes: 'نعم', // Resources.Yes
  no: 'لا', // Resources.No
  mandatory: 'إجباري', // Resources.Mandatory
  optional: 'اختياري', // Resources.Optional

  exportExcel: 'تصدير إلى أكسل',
  exportPdf: 'تصدير إلى PDF',
  exportFailed: 'تعذر تصدير الملف، فضلا حاول مرة أخرى',
  close: 'إغلاق', // Users.btnClose
}
